import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  wrapperBreadcrumbs: {
    fontWeight: 'bold',
  },
  firstStep: {
    color: theme.palette.primary.main,
  },
}));
